import { render, staticRenderFns } from "./_video.vue?vue&type=template&id=784af92a&scoped=true"
import script from "./_video.vue?vue&type=script&lang=js"
export * from "./_video.vue?vue&type=script&lang=js"
import style0 from "./_video.vue?vue&type=style&index=0&id=784af92a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784af92a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/Users/daiyu/Desktop/work-code/bantervideo/components/Header/index.vue').default,VideoPlayer: require('/Users/daiyu/Desktop/work-code/bantervideo/components/VideoPlayer.vue').default,AdmSlotPreload: require('/Users/daiyu/Desktop/work-code/bantervideo/components/AdmSlotPreload.vue').default,AdmSlot: require('/Users/daiyu/Desktop/work-code/bantervideo/components/AdmSlot.vue').default,ContentItemCard: require('/Users/daiyu/Desktop/work-code/bantervideo/components/ContentItemCard.vue').default,InfiniteScrollList: require('/Users/daiyu/Desktop/work-code/bantervideo/components/InfiniteScrollList.vue').default,Footer: require('/Users/daiyu/Desktop/work-code/bantervideo/components/Footer/index.vue').default,BackTop: require('/Users/daiyu/Desktop/work-code/bantervideo/components/BackTop/index.vue').default})
